import { render, staticRenderFns } from "./NewsMultiple.vue?vue&type=template&id=8d065d94&scoped=true&"
import script from "./NewsMultiple.vue?vue&type=script&lang=ts&"
export * from "./NewsMultiple.vue?vue&type=script&lang=ts&"
import style0 from "./NewsMultiple.vue?vue&type=style&index=0&id=8d065d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d065d94",
  null
  
)

export default component.exports